import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const MajakIcon = ({ type, className, ...rest }) => {
  const classString = cn('majakicon', `majakicon-${type}`, className);

  return <i className={classString} {...rest} />;
};

MajakIcon.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default MajakIcon;



// WEBPACK FOOTER //
// ./src/common/components/MajakIcon.js